module.exports = __webpack_public_path__ + "img/ecommerce.category.content_image_18.adf96b7d.webp";